import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import styles from './TimePickerSlider.module.css';
import { format } from 'date-fns';
const TimePickerSlider = ({ times, handleSelect }) => {
  const [selectedTime, setSelectedTime] = useState(times[0]);

  const onSelect = (time) => {
    setSelectedTime(time);
    handleSelect(time);
  };

  return (
    <Swiper spaceBetween={5} slidesPerView={'auto'} className={`${styles.swiperContainer}`}>
      {times.map((p, i) => (
        <SwiperSlide key={i}>
          <button
            onClick={() => onSelect(p)}
            className={`${styles.dateButton} ${selectedTime === p ? styles.selected : null}`}
            type='button'
          >
            <div className='font-tiny'>{format(new Date(p), 'h:mm aaa')}</div>
          </button>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default TimePickerSlider;
